"use client";
"use strict";
import React, { useState, useEffect, useContext } from 'react'
import { session } from '../../utils/AuthSession'
import { API } from '../../utils/api'
import { Api } from '../../utils/apiServer'
import DefaultVoucher from "../../assets/default-voucher.png"
import { AiOutlineHistory, AiOutlineGift, AiOutlineTrophy } from "react-icons/ai";
import { BiStore } from "react-icons/bi";
import { Card } from "react-daisyui"
import { ThemeContext } from "../../context/ThemeContext";
import {
    useNavigate
} from "react-router-dom";

const Home = () => {
    const [authSession] = useState(session())
    const [profile, setProfile] = useState(null)
    const [loading, setLoading] = useState(true)
    const { primaryColor } = useContext(ThemeContext)
    const navigate = useNavigate()

    useEffect(() => {
        init()
    }, [])

    const init = async () => {
        setLoading(true)
        const params = {
            access: 'auth',
            method: API.PROFILE.type,
            url: API.PROFILE.url,
            reqBody: {}
        }
        const response = await Api(params);
        if (response) {
            setProfile(response.data)
        }
        setLoading(false)
    }

    const quickActions = [
        {
            id: 1,
            title: "Riwayat",
            subtitle: "Transaksi",
            icon: <AiOutlineHistory className="text-2xl" />,
            link: "/history",
            color: "from-blue-500 to-blue-600"
        },
        {
            id: 2,
            title: "Merchant",
            subtitle: "Partner",
            icon: <BiStore className="text-2xl" />,
            link: "/merchant",
            color: "from-green-500 to-green-600"
        }
    ]

    const LoadingSkeleton = () => (
        <div className="animate-pulse space-y-4">
            <div className="bg-gray-200 h-24 rounded-xl"></div>
            <div className="flex gap-4">
                <div className="bg-gray-200 h-20 flex-1 rounded-lg"></div>
                <div className="bg-gray-200 h-20 flex-1 rounded-lg"></div>
            </div>
            <div className="bg-gray-200 h-32 rounded-lg"></div>
        </div>
    )

    if (loading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
                <div className="mx-auto max-w-sm px-5 py-6">
                    <LoadingSkeleton />
                </div>
            </div>
        )
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
            <div className="mx-auto max-w-sm px-5 py-6">
                <div className='flex flex-col space-y-6 scrollbar-hide'>

                    {/* Welcome Header Card */}
                    <Card className="bg-gradient-to-r from-white to-gray-50 shadow-xl border-0">
                        <Card.Body className="p-6 text-center">
                            <div className="flex items-center justify-center mb-3">
                                <div className={`w-16 h-16 rounded-full bg-gradient-to-r ${primaryColor ? 'from-red-500 to-red-600' : 'from-blue-500 to-blue-600'} flex items-center justify-center text-white shadow-lg`}>
                                    <AiOutlineTrophy className="text-2xl" />
                                </div>
                            </div>
                            <h2 className="text-lg font-bold text-gray-800 mb-1">
                                Selamat Datang!
                            </h2>
                            <p className="text-gray-600 font-medium mb-3">
                                {profile?.firstname ? profile.firstname : authSession.user.phone}
                            </p>
                            <div className="bg-gradient-to-r from-amber-400 to-orange-500 text-white p-4 rounded-lg">
                                <div className="text-sm opacity-90">Total Poin Anda</div>
                                <div className="text-3xl font-bold">
                                    {profile?.point?.point ? profile.point.point.toLocaleString() : 0}
                                </div>
                                <div className="text-xs opacity-75 mt-1">poin</div>
                            </div>
                        </Card.Body>
                    </Card>

                    {/* Quick Actions */}
                    <div className="space-y-3">
                        <h3 className="text-lg font-semibold text-gray-800 px-2">Akses Cepat</h3>
                        <div className="grid grid-cols-2 gap-4">
                            {quickActions.map((action) => (
                                <Card
                                    key={action.id}
                                    className="bg-white shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer border-0 group"
                                    onClick={() => navigate(action.link)}
                                >
                                    <Card.Body className="p-4 text-center">
                                        <div className={`w-12 h-12 rounded-lg bg-gradient-to-r ${action.color} flex items-center justify-center text-white mx-auto mb-3 group-hover:scale-110 transition-transform duration-300`}>
                                            {action.icon}
                                        </div>
                                        <h4 className="font-semibold text-gray-800 text-sm">{action.title}</h4>
                                        <p className="text-xs text-gray-500 mt-1">{action.subtitle}</p>
                                    </Card.Body>
                                </Card>
                            ))}
                        </div>
                    </div>

                    {/* Voucher Section */}
                    <Card className="bg-white shadow-lg border-0">
                        <Card.Body className="p-6">
                            <div className="flex items-center justify-between mb-4">
                                <div>
                                    <h3 className="text-lg font-semibold text-gray-800">Voucher Saya</h3>
                                    <p className="text-sm text-gray-500">Koleksi voucher Anda</p>
                                </div>
                                <div className="w-10 h-10 rounded-lg bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center text-white">
                                    <AiOutlineGift className="text-lg" />
                                </div>
                            </div>

                            {profile?.member_voucher?.length === 0 ? (
                                <div className="text-center py-8">
                                    <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-3">
                                        <AiOutlineGift className="text-2xl text-gray-400" />
                                    </div>
                                    <p className="text-gray-500 font-medium">Belum ada voucher</p>
                                    <p className="text-sm text-gray-400 mt-1">Yuk mulai kumpulkan poin!</p>
                                </div>
                            ) : (
                                <div className="grid grid-cols-1 gap-3">
                                    {profile?.member_voucher?.map((mv, i) => (
                                        <Card key={i} className="bg-gradient-to-r from-gray-50 to-white border border-gray-100 shadow-sm">
                                            <Card.Body className="p-4">
                                                <div className="flex items-center space-x-3">
                                                    <img
                                                        src={mv.voucher.voucher_image === null ? DefaultVoucher : mv.voucher.voucher_image}
                                                        alt="Voucher"
                                                        className="w-12 h-12 rounded-lg object-cover shadow-sm"
                                                    />
                                                    <div className="flex-1">
                                                        <h4 className="font-semibold text-gray-800 text-sm">
                                                            {mv.voucher.voucher_name || `Voucher #${i + 1}`}
                                                        </h4>
                                                        <p className="text-xs text-gray-500 mt-1">
                                                            {mv.voucher.voucher_description || 'Deskripsi voucher'}
                                                        </p>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    ))}
                                </div>
                            )}
                        </Card.Body>
                    </Card>

                </div>
            </div>
        </div>
    )
}

export default Home